import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DensityContext, withStyles } from '@jpmuitk/theme';
import { style } from './style';
/**
 * Panel component that acts as wrapper around a node
 *
 * @example
 * const PanelExample = () => (
 *   <Panel>
 *     <p>This is a panel around some text.</p>
 *   </Panel>
 * );
 *
 */

var Panel = /*#__PURE__*/forwardRef(function Panel(props, ref) {
  var contextDensity = useContext(DensityContext);

  var classes = props.classes,
      className = props.className,
      children = props.children,
      _props$density = props.density,
      density = _props$density === void 0 ? contextDensity : _props$density,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      rest = _objectWithoutProperties(props, ["classes", "className", "children", "density", "variant"]);

  return /*#__PURE__*/React.createElement("div", _assign({
    className: classnames(classes.root || 'root', classes["".concat(density, "Density")], className, _defineProperty({}, classes.secondary, variant === 'secondary')),
    ref: ref
  }, rest), children);
});
process.env.NODE_ENV !== "production" ? Panel.propTypes = {
  /**
   * Node to be contained in a Panel.
   */
  children: PropTypes.node.isRequired,

  /**
   * The density of a component affects the style of the layout.
   * A high density component uses minimal sizing and spacing to convey the intended UI design.
   * Conversely, a low density component, maximizes the use of space and size to convey the UI Design.
   */
  className: PropTypes.string,

  /**
   * The className(s) of the component.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * Class selectors required by theme.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * Determines the variant of the component. Must be one of: 'regular', 'secondary'. Default is 'regular'
   */
  variant: PropTypes.oneOf(['regular', 'secondary'])
} : void 0; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(style, {
  name: 'Panel'
})(Panel);